export const VAPID_KEY = 'BJwj6MMCH0RDyyR56HWfmiPeHRnO9dbxmehboXlcAatPRaxhD4xXKZTb-6Xkfwd5nHvYUgsJXovWB2mhi7dd7dY'
export default { VAPID_KEY }
